import { PerspectiveCamera, OrbitControls, Clone, Html, Environment } from "@react-three/drei";
import { useEffect, useRef, useState } from "react";
import { useSnapshot } from "valtio";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import artefaktText from "../../../SalzzeitOverlay/src/museumData/entryRoomText.json";
import artefaktTextEn from "../EntryRoom/text/entryRoomText_en.json";
import { stateArtefactTexts, stateEnglisch } from "../store";

export default function ExperienceModelViewer({ modelArray, currentMuseumId }) {
  const modelRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modelArraySize, setModelArraySize] = useState(false);
  const snapEnglisch = useSnapshot(stateEnglisch);
  const isEn = snapEnglisch.isEnglisch;

  const prevSlide = () => {
    setCurrentIndex((i) => (i === 0 ? modelArray.length - 1 : i - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((i) => (i === modelArray.length - 1 ? 0 : i + 1));
  };

  useEffect(() => {
    const findEntryRoomText = (sceneName, entries) => {
      const fullId = `Position_Artefakt_${sceneName}`;
      return entries.find((entry) => entry.Id === fullId) || null;
    };

    const applyText = () => {
      if (!modelArray[currentIndex]) return;
      const sceneName = modelArray[currentIndex].scene.name;
      if (!sceneName) return;
      const textSource = stateEnglisch.isEnglisch ? artefaktTextEn : artefaktText;
      const entry = findEntryRoomText(sceneName, textSource);
      if (entry) {
        stateArtefactTexts.Titel = entry.Titel;
        stateArtefactTexts.Text = entry.Text[0];

        if (modelRef.current) {
          const scale = entry.Scale;
          const rotation = entry.Rotation;

          if (typeof scale === "number") {
            modelRef.current.scale.set(scale, scale, scale);
          } else if (Array.isArray(scale)) {
            modelRef.current.scale.set(...scale);
          } else if (scale?.x !== undefined) {
            modelRef.current.scale.set(scale.x, scale.y, scale.z);
          }

          if (Array.isArray(rotation)) {
            modelRef.current.rotation.set(...rotation);
          } else if (rotation?.x !== undefined) {
            modelRef.current.rotation.set(rotation.x, rotation.y, rotation.z);
          }
        }
      } else {
        stateArtefactTexts.Titel = "";
        stateArtefactTexts.Text = "";
      }
    };

    // Try immediately (works on revisit when scene.name is already cached)
    applyText();
    // Defer to catch first-load case where parent useEffect sets scene.name after ours
    const timer = setTimeout(applyText, 0);
    return () => clearTimeout(timer);
  }, [currentIndex, currentMuseumId, isEn]);

  useEffect(() => {
    setModelArraySize(modelArray.length > 1);
  }, [currentIndex, currentMuseumId]);

  return (
    <>
      <Environment preset="city" background={false} intensity={1} resolution={256} />
      <directionalLight />
      <ambientLight intensity={0.5} />
      <PerspectiveCamera makeDefault position={[0, 0, 30]} />
      <OrbitControls />
      <Clone ref={modelRef} object={modelArray[currentIndex].scene} />

      {modelArraySize && (
        <Html>
          <div
            className="absolute top-1/2 -translate-y-1/2 right-32 text-2xl rounded-full p-2 bg-black/40 text-white cursor-pointer"
            onClick={prevSlide}
          >
            <BsChevronCompactLeft size={25} />
          </div>
          <div
            className="absolute top-1/2 -translate-y-1/2 left-32 text-2xl rounded-full p-2 bg-black/40 text-white cursor-pointer"
            onClick={nextSlide}
          >
            <BsChevronCompactRight size={25} />
          </div>
        </Html>
      )}
    </>
  );
}
